import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOrganisations } from 'app/entities/organisation/organisation.reducer';
import { getEntities as getEmployees } from 'app/entities/employee/employee.reducer';
import { getEntities as getCustomers } from 'app/entities/customer/customer.reducer';
import { createEntity, getEntity, reset, updateEntity } from './supplier.reducer';

export const SupplierUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const organisations = useAppSelector(state => state.organisation.entities);
  const employees = useAppSelector(state => state.employee.entities);
  const customers = useAppSelector(state => state.customer.entities);
  const supplierEntity = useAppSelector(state => state.supplier.entity);
  const loading = useAppSelector(state => state.supplier.loading);
  const updating = useAppSelector(state => state.supplier.updating);
  const updateSuccess = useAppSelector(state => state.supplier.updateSuccess);

  const handleClose = () => {
    navigate('/supplier');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOrganisations({}));
    dispatch(getEmployees({}));
    dispatch(getCustomers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...supplierEntity,
      ...values,
      organisation: organisations.find(it => it.id.toString() === values.organisation?.toString()),
      supplierAdmin: employees.find(it => it.id.toString() === values.supplierAdmin?.toString()),
      customers: mapIdList(values.customers),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...supplierEntity,
          organisation: supplierEntity?.organisation?.id,
          supplierAdmin: supplierEntity?.supplierAdmin?.id,
          customers: supplierEntity?.customers?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.supplier.home.createOrEditLabel" data-cy="SupplierCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.supplier.home.createOrEditLabel">
              Create or edit a Supplier
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="supplier-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.name')}
                id="supplier-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.origin')}
                id="supplier-origin"
                name="origin"
                data-cy="origin"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.accessToken')}
                id="supplier-accessToken"
                name="accessToken"
                data-cy="accessToken"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.logoURL')}
                id="supplier-logoURL"
                name="logoURL"
                data-cy="logoURL"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.description')}
                id="supplier-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.status')}
                id="supplier-status"
                name="status"
                data-cy="status"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.createDate')}
                id="supplier-createDate"
                name="createDate"
                data-cy="createDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.updateDate')}
                id="supplier-updateDate"
                name="updateDate"
                data-cy="updateDate"
                type="date"
              />
              <ValidatedField
                id="supplier-organisation"
                name="organisation"
                data-cy="organisation"
                label={translate('crawlerBackendApp.supplier.organisation')}
                type="select"
              >
                <option value="" key="0" />
                {organisations
                  ? organisations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="supplier-supplierAdmin"
                name="supplierAdmin"
                data-cy="supplierAdmin"
                label={translate('crawlerBackendApp.supplier.supplierAdmin')}
                type="select"
              >
                <option value="" key="0" />
                {employees
                  ? employees.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.supplier.customers')}
                id="supplier-customers"
                data-cy="customers"
                type="select"
                multiple
                name="customers"
              >
                <option value="" key="0" />
                {customers
                  ? customers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/supplier"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SupplierUpdate;
